import {
  Input,
  Component,
  OnInit,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';

import { MapHeaderComponent } from '../../map-header/map-header.component';
import { FeatureNameComponent } from '../feature-name/feature-name.component';
interface PanelData {
  header: string[];
  features: { [key: string]: any }[];
}
@Component({
  selector: 'app-uidrop-down-search',
  templateUrl: './uidrop-down-search.component.html',
  styleUrls: ['./uidrop-down-search.component.css'],
})
export class UIdropDownSearchComponent implements OnInit, OnChanges {
  @ViewChild(MapHeaderComponent, { static: false })
  private MapHeaderComponent!: MapHeaderComponent;
  @Input() searchValue: any;
  @Input() searchType: any;
  @Output() dataloaded = new EventEmitter<boolean>();
  @Output() doneSearch = new EventEmitter<boolean>();
  searchData: any[] = [];
  searchDataDemo: any[] = [];
  data: any[] = [];
  subscribe: any;
  noResult: any;
  selectedData: any
  showNow: any;
  displayData: any = [];
  objectData: any = {};
  SortOrder: any = [];
  backup: any;
  selectedFeatures: any;
  boundaries: any;
  decrypted: any;
  keyMes = 'mapId';
  panelContainerEl: any
  mapId: any;
  constructor(
    private MapService: MapServiceService,
    private sideNavService: SideNavService,
    private global: GlobalService
  ) { }
  ngOnInit(): void {
    //
    this.mapId = this.MapService.mapData.map_data.map_data.id.toString();
    this.sideNavService.loadfirstTime.subscribe(() => {
      this.boundaries = this.MapService.mapData.map_data.map_data.layers;
    });
    this.displayData = [];
    this.noResult = false;
    this.sideNavService.onResize();
  }

  getSearchDetails(val: any) {
    const lowercasedObj = Object.keys(val).reduce((newObj: any, key) => {
      newObj[key.toLowerCase().split(' ').join('_')] = val[key];
      return newObj;
    }, {});
    this.global.toggleLoader(true);
    this.searchValue = [];
    let id1: any;
    if (lowercasedObj?.layer_id) {
      id1 = lowercasedObj.layer_id;
    } else {
      for (let i = 0; i < this.boundaries.length; i++) {
        if (this.boundaries[i].name == lowercasedObj.Layer) {
          id1 = this.boundaries[i].id;
          break;
        }
      }
    }

    // const id = this.MapService.getLayersId()

    this.MapService.getParcelData(
      'parcel',
      lowercasedObj.id.toString(),
      parseInt(this.mapId),
      '',
      '',
      false,
      false,
      id1.toString(),
      2,
      '',
      ''
    ).subscribe((res) => {
      this.MapService.ParcelData = [];
      this.MapService.ParcelData = res.features;
      // localStorage.removeItem('seletedFeature');
      // localStorage.setItem('seletedFeature', JSON.stringify(res.features));

      this.selectedFeatures = res.features;
      const fields: any = {};
      if (this.selectedFeatures.length > 1) {
        this.MapService.parcel = '';
        this.MapService.parcels = [];
        for (let i = 0; i < this.selectedFeatures.length; i++) {
          this.MapService.multiParcelId.push(this.selectedFeatures[i].id);
          if (fields[this.selectedFeatures[i].layer_id]) {
            fields[this.selectedFeatures[i].layer_id.toString()].push(
              this.selectedFeatures[i].id.toString()
            );
          } else {
            fields[this.selectedFeatures[i].layer_id] = [];
            fields[this.selectedFeatures[i].layer_id.toString()].push(
              this.selectedFeatures[i].id.toString()
            );
          }
          this.MapService.parcel = JSON.stringify(fields);
          this.MapService.featureLayersId.push(
            this.selectedFeatures[i].layer_id
          );
          this.MapService.featureLayerId = [
            ...new Set(this.MapService.featureLayersId),
          ].toString();
          this.MapService.polygonGeometry = this.selectedFeatures[i].geom_wkt;
          this.MapService.pointGeometry = this.selectedFeatures[i].ctrd_wkt;
        }
      } else {
        this.MapService.parcel = '';
        this.MapService.parcels = [];
        for (let i = 0; i < this.selectedFeatures.length; i++) {
          this.MapService.multiParcelId.push(this.selectedFeatures[i].id);
          // multiParcel
          this.MapService.multiParcel = false;
          // parcel ID
          this.MapService.parcels.push(this.selectedFeatures[i].id);
          this.MapService.parcel = [
            ...new Set(this.MapService.parcels),
          ].toString();
          // Feature Layer Id
          this.MapService.featureLayersId.push(
            this.selectedFeatures[i].layer_id
          );
          this.MapService.featureLayerId = [
            ...new Set(this.MapService.featureLayersId),
          ].toString();
          this.MapService.polygonGeometry = this.selectedFeatures[i].geom_wkt;
          this.MapService.pointGeometry = this.selectedFeatures[i].ctrd_wkt;
        }
      }
      this.sideNavService.decideComponent(res);
      this.doneSearch.emit(true);
    });
  }

  ngOnChanges() {
    this.sideNavService.onResize();
    this.searchData = [];
    // if(this.searchValue.length>0){
    //   this.showNow = false;
    // }
    if (this.searchValue.length > 1) {
      if (this.searchType === 'autoComplete') {
        // this.global.toggleLoader(true)
        this.showNow = false;
        this.noResult = false;
        this.sideNavService.onResize();
        this.sideNavService.closeRightSideNav();
        if (this.subscribe) {
          this.subscribe.unsubscribe();
        }
        this.mapId = this.MapService.mapData.map_data.map_data.id.toString();
        (this.subscribe = this.MapService.getParcelData(
          'autocomplete',
          '',
          parseInt(this.mapId),
          '',
          '',
          true,
          false,
          '',
          '',
          this.searchValue.toString(),
          ''
        ).subscribe((res) => {
          this.MapService.searchResult = true;
          this.sideNavService.onResize();
          if (res && res.length > 0) {
            const panelData: PanelData[] = res;
            panelData.forEach((table) => {
              table.header = table.header.map((h) => {
                return h.split('_').map((word) => {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                }).join(' ');
              });
              // table.header.splice(table.header.indexOf('eom'), 1);
            });
            panelData.forEach((table) => {
              table.features = table.features.map((feature) => {
                delete feature.geom
                const transformedFeature: any = {};
                Object.keys(feature).forEach((key) => {
                  const transformedKey = key.split('_').map((word) => {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                  }).join(' ');
                  transformedFeature[transformedKey] = feature[key];
                });
                return transformedFeature;
              });
            });
            panelData.forEach((table) => {
              const header = table.header;
              table.features.forEach((feature) => {
                const featureKeys = Object.keys(feature);
                const isSame = header.every((val) => featureKeys.includes(val));
                if (!isSame) {
                  table.header = header.filter((val) => featureKeys.includes(val));
                }
              });
            });

            this.searchData = panelData
            this.backup = this.searchData;
            this.displayData = [];

            // this.searchData = [];
            // this.searchData = this.displayData;

            this.noResult = false;
            this.sideNavService.onResize();
            this.dataloaded.emit(true);
            this.showNow = true;
          } else {
            this.dataloaded.emit(true);
            this.noResult = true;
            this.sideNavService.onResize();
          }
        })),
          () => {
            this.searchData = [];
            this.dataloaded.emit(true);
          };
      } else if (this.searchType === 'quick') {
        this.showNow = false;
        this.searchData = [];
        this.subscribe.unsubscribe();
        // this.global.toggleLoader(true)
        this.MapService.getParcelData(
          'quick',
          '',

          parseInt(this.mapId),
          '',
          '',
          false,
          false,
          '',
          '',
          this.searchValue.toString(),
          ''
        ).subscribe((res: any) => {
          // this.showNow = false;
          this.MapService.searchResult = true;
          //for removing focus from search
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
          this.sideNavService.onResize();
          if (res == null) {
            // this.global.toggleLoader(true)
            this.sideNavService.rightMenuClicked({
              component: FeatureNameComponent,
              data: null,
              history: false,
              push: true,
            });
            this.doneSearch.emit(true);
            this.dataloaded.emit(false);
          }
          this.searchValue = [];

          this.searchData = res;
          this.dataloaded.emit(true);
          // this.sideNavService.searchClicked(res.features);
          // localStorage.removeItem('seletedFeature');
          // localStorage.setItem('seletedFeature', JSON.stringify(res.features));
          this.MapService.ParcelData = res.features;
          this.selectedFeatures = res.features;
          const fields: any = {};
          if (this.selectedFeatures.length > 1) {
            this.MapService.parcel = '';
            this.MapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.MapService.multiParcelId.push(this.selectedFeatures[i].id);
              if (fields[this.selectedFeatures[i].layer_id]) {
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              } else {
                fields[this.selectedFeatures[i].layer_id] = [];
                fields[this.selectedFeatures[i].layer_id.toString()].push(
                  this.selectedFeatures[i].id.toString()
                );
              }
              this.MapService.parcel = JSON.stringify(fields);
              this.MapService.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.MapService.featureLayerId = [
                ...new Set(this.MapService.featureLayersId),
              ].toString();
              this.MapService.polygonGeometry =
                this.selectedFeatures[i].geom_wkt;
              this.MapService.pointGeometry = this.selectedFeatures[i].ctrd_wkt;
            }
          } else {
            this.MapService.parcel = '';
            this.MapService.parcels = [];
            for (let i = 0; i < this.selectedFeatures.length; i++) {
              this.MapService.multiParcelId.push(this.selectedFeatures[i].id);
              // multiParcel
              this.MapService.multiParcel = false;
              // parcel ID
              this.MapService.parcels.push(this.selectedFeatures[i].id);
              this.MapService.parcel = [
                ...new Set(this.MapService.parcels),
              ].toString();
              // Feature Layer Id
              this.MapService.featureLayersId.push(
                this.selectedFeatures[i].layer_id
              );
              this.MapService.featureLayerId = [
                ...new Set(this.MapService.featureLayersId),
              ].toString();
              this.MapService.polygonGeometry =
                this.selectedFeatures[i].geom_wkt;
              this.MapService.pointGeometry = this.selectedFeatures[i].ctrd_wkt;
            }
          }
          this.sideNavService.decideComponent(res);

          this.doneSearch.emit(true);
        }),
          () => {
            this.searchData = [];
            this.dataloaded.emit(true);
          };
      }
    } else {
      this.searchData = [];
      this.dataloaded.emit(true);
    }
  }

}
